<template>
  <!-- Navbar -->
  <div id="navbar_root">
  <b-navbar variant="faded" type="light" style="background-color: #22409a;">
    <!-- Logo - esquerda -->
    <b-navbar-brand href="https://dnc.group">
      <img src="../assets/img/logo-white.png" class="d-inline-block align-top" style="margin-left:13px;">
    </b-navbar-brand>
    <!-- Menu - direita -->
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <a href="#" class="home-button"> Voltar para Home </a>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<style scoped>
.dropdown-toggle::after {
    display:none;
}
</style>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      token: null,
      btn_logado: 'Log in'
    }
  },
  methods: {
    // Função de log in e log out
    verificaLogin(){
      // Usuário logado
      if (this.token != null){
        this.$cookies.remove("token");
      }
      window.location.href = '/';
    }
  },
  mounted() {
    this.token = this.$cookies.get("token");
    if (this.token != null){
      this.btn_logado = 'Log out';
    }
  }
}

</script>
